import type { FaireProductEntity } from "../../entity_types/product";

export const p_wgmzp4gaxv: FaireProductEntity = {
  token: "p_wgmzp4gaxv",
  type: "product",
  name: "rocky's matcha Houjicha 20g",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/30fda343c62ef6e27870707fb2f7b223c768254b2923bca01c3fc19b5bf80f7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ddd1d73ca73a9fd6fe31aa11a5e7fc0d3666bf00e23bc6989cdc64dd73394439.jpeg",
    "https://cdn.faire.com/fastly/7b08d084e82b58b46a6850e3abe6aa150f5ab6ce20b18d69c9c203b5074bcd39.jpeg",
    "https://cdn.faire.com/fastly/bef4439bb179eeadf2bc4bc0a8c86d5261ee379c9e71aa7119d9226eee19d312.png"
  ],
  priceDollars: 12,
  description: "rocky's matcha is thrilled to offer our signature blend of houjicha from award winning, fifth generation tea farmer, Mr. Kiyoharu Tsuji.\n\nHoujicha—directly translated in Japanese to ‘roasted tea’—is a type of green tea recognized for its smoky, nutty flavor profile and light-to-dark brown appearance. Both unique qualities are the result of a similarly distinctive preparation process: Tea leaves and twigs are slow-roasted in a porcelain pot over a charcoal flame before being ground into powder. The roasting process gives houjicha its signature aroma and appearance, while reducing its caffeine content, making it a mild alternative to other green teas.\n\nOur signature houjicha uses stems and leaves from Tsujiki's tencha and is slow roasted at a relatively low temperature to preserve the flavor and taste of the tea.\n\n\n• Houjicha\n• Region: Uji, Japan\n• Net Weight: 20g",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:20.517Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
